import React from 'react';
import styles from './Layout.module.scss';
import classNames from 'classnames';

interface LayoutProps extends React.PropsWithChildren {
  className: string;
}

export const Layout: React.FC<LayoutProps> = (props) => {
  const { className, children } = props;

  return (
    <div id="layout" className={classNames(styles.Layout, className)}>
      {children}
    </div>
  )
}